export const VNORDERTOTAL_SET_LAST_UUID_AND_MENU_ID = 'VNORDERTOTAL_SET_LAST_UUID_AND_MENU_ID'
export const VNORDERTOTAL_RESET_LAST_UUID_AND_MENU_ID = 'VNORDERTOTAL_RESET_LAST_UUID_AND_MENU_ID'
